import React from 'react';
import AgoraActiveCall from './AgoraActiveCall';
import LiveKitActiveCall from './LiveKitActiveCall';

/**
 * Provider router — selects the correct call implementation based on tokens.provider.
 * MeetingWindow.jsx imports this and passes tokens through; no changes needed there.
 */
const ActiveCall = (props) => {
    if (props.tokens?.provider === 'livekit') {
        return <LiveKitActiveCall {...props} />;
    }

    // Default: agora (also handles undefined provider for backward compatibility)
    return <AgoraActiveCall {...props} />;
};

export default ActiveCall;
